import { PDFDocument, degrees } from 'pdf-lib';

/**
 * Apply per-page rotation deltas and trigger a local PDF download.
 *
 * Each page entry carries a `userRotation` value (0 / 90 / 180 / 270) that
 * represents the ADDITIONAL rotation the user requested on top of whatever
 * rotation is already baked into the source PDF.  pdf-lib reads the existing
 * rotation angle and adds the user's delta before writing the new file.
 *
 * @param {ArrayBuffer} arrayBuffer - Source PDF bytes
 * @param {{ originalIndex: number, userRotation: number }[]} pages - Page list
 * @param {string} fileName - Original file name (used as download base name)
 */
export async function exportRotatedPdf(arrayBuffer, pages, fileName) {
  const pdfDoc = await PDFDocument.load(arrayBuffer);
  const pdfPages = pdfDoc.getPages();

  for (const page of pages) {
    const pdfPage = pdfPages[page.originalIndex];
    const existingAngle = pdfPage.getRotation().angle;
    const newAngle = ((existingAngle + page.userRotation) % 360 + 360) % 360;
    pdfPage.setRotation(degrees(newAngle));
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  const base = fileName.replace(/\.pdf$/i, '');
  const outputName = `${base}-rotated.pdf`;

  const a = document.createElement('a');
  a.href = url;
  a.download = outputName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  setTimeout(() => URL.revokeObjectURL(url), 15000);
}
